import { sendGTMEvent } from '@next/third-parties/google'
import environment from 'environment'

import CookieService from 'services/cookie.service'

const signalEvent = (action: string) => {
  const userId = CookieService.get('tbId') || null

  if (environment.nodeEnv !== 'production') console.log(`GTM Event log: "${action}"`)

  sendGTMEvent({ event: 'app_event', app_event_name: action, user_id: userId })
}

export default {
  signalEvent,
}
